export default function About() {
  return (
    <section id="about" className="py-32 bg-gradient-to-b from-white to-gray-50">
      <div className="max-w-[1400px] mx-auto px-20">
        <div className="mb-12">
          <span className="inline-block px-4 py-2 bg-teal-100 text-teal-800 text-xs font-semibold tracking-wider rounded-full uppercase">
            Who We Are
          </span>
        </div>
        
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-start">
          <div className="space-y-4">
            <h2 className="text-5xl font-light italic text-gray-400">Expert Team</h2>
            <h2 className="text-5xl font-bold text-gray-900">Building the Future</h2>
          </div>
          
          <div className="space-y-6">
            <p className="text-lg text-gray-600 leading-relaxed">
              OPTIMUM d.o.o. is a dedicated team of iOS development experts committed to creating innovative mobile applications that make a difference. We specialize in developing solutions that prioritize user experience, security, and performance.
            </p>
            <p className="text-lg text-gray-600 leading-relaxed">
              Our philosophy is simple: create applications that users love and trust. Every line of code we write, every feature we design, is crafted with the end user in mind. We believe in the power of technology to improve daily life, and we're passionate about bringing that vision to reality through our iOS applications.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
